
  import {mapState} from 'vuex'
  import pickerColor from "@/components/helang-pickerColor.vue";
  import _ from "lodash";
  import {Toast} from "vant";

  export default {
    components: {pickerColor},
    props: {
      text: {
        type: Object,
      },
    },
    data(){
      return{
        backup: '',
        selectedMove:'',
        content: '',
        type: '',
        activeNames: ['1'],
        moveIndex: 0,
        speedIndex: 0,
        Alignment: [
          {value: '1', 'name': this.$t('append_field.topLeft')},
          {value: '2', 'name': this.$t('append_field.topCenter')},
          {value: '3', 'name': this.$t('append_field.topRight')},
          {value: '4', 'name': this.$t('append_field.leftCenter')},
          {value: '5', 'name': this.$t('append_field.center')},
          {value: '6', 'name': this.$t('append_field.rightCenter')},
          {value: '7', 'name': this.$t('append_field.bottomLeft')},
          {value: '8', 'name': this.$t('append_field.bottomCenter')},
          {value: '9', 'name': this.$t('append_field.bottomRight')}
        ],
        showPickerColor: false,
        bottomPickerColor: 0,
        taBgColor: '#00000000',
        taColor: "000000",
        fontColor: false,
        bjColor: false,
        placeholder: this.$t('append_field.enterContent'),
        showScrollSpeedPopup: false,
        showScrollDirectionPopup: false,
        showAlignmentPopup: false,
        selectedSpeed: '1', // 示例数据
        selectedDirection: '0', // 示例数据
        selectedAlignment: '5', // 示例数据
        speedOptions: [
          { value: '0', label: this.$t('append_field.static') },
          { value: '1', label: this.$t('append_field.slow') },
          { value: '2', label: this.$t('append_field.medium') },
          { value: '3', label: this.$t('append_field.fast') }
        ],
        directionOptions: [
          { value: '0', label: this.$t('append_field.leftToRights') },
          { value: '1', label: this.$t('append_field.rightToLefts') },
          { value: '2', label: this.$t('append_field.bottomToTops') }
        ],
      }
    },
    mounted() {
      if(this.text && this.text.txList && this.text.txList[0]){
        this.content=this.text.txList[0].taContent
        this.type=this.text.coType
      }
      if(this.componentsList[this.controlIndex]&&this.componentsList[this.controlIndex].txList[0]){

        this.taColor = this.componentsList[this.controlIndex].txList[0].taColor
        this.taBgColor = this.componentsList[this.controlIndex].txList[0].taBgColor
        this.backup = _.cloneDeep(this.$store.state.componentsList[this.controlIndex])
        this.selectedSpeed=this.componentsList[this.controlIndex].txList[0].taMoveSpeed
        this.selectedDirection=this.componentsList[this.controlIndex].txList[0].taMove
        this.selectedAlignment=this.componentsList[this.controlIndex].txList[0].taAlignment
      }

    },
    methods: {
      submit() {
        if (this.content === '') {
          Toast(this.$t('append_field.enterText'))
          return
        }else {
          Toast(this.$t('append_field.add_success'))
        }
        this.$emit('setText', this.content)
      },
      close() {
        this.$store.state.componentsList[this.controlIndex].txList = this.backup.txList
        this.$set(this.$store.state.componentsList[this.controlIndex], this.controlIndex, this.backup)
        this.$emit('close')
      },
      getPickerColor(color) {
        /* 隐藏弹窗 */
        this.showPickerColor = false
        this.activeNames = []
        /* 判断颜色值是否有效 */
        if (color) {
          if (this.fontColor) {
            this.taColor = color
            this.$store.state.componentsList[this.controlIndex].txList[0].taColor = color
          } else if (this.bjColor) {
            this.taBgColor = color
            this.$store.state.componentsList[this.controlIndex].txList[0].taBgColor = color
          }
          this.$set(this.componentsList, this.controlIndex, this.componentsList[
              this.controlIndex])
        }
      },
      setactiveNames(id) {
        this.fontColor = false
        this.bjColor = false
        if (id === '1') {
          this.fontColor = true
          this.showPickerColor = true
        } else if (id === '2') {
          this.bjColor = true
          this.showPickerColor = true
        }
      },
      edit() {
        this.$emit('edit')
      },
      fullscreen() {
        this.$emit('fullscreen')
      },
      selectSpeed(speed) {
        this.selectedSpeed = speed;
      },
      selectDirection(direction) {
        this.selectedDirection = direction
      },
      selectAlignment(alignment) {
        this.selectedAlignment = alignment
      },
      onSelectSpeed() {
        this.text.txList[0].taMoveSpeed = this.selectedSpeed
        this.showScrollSpeedPopup = false
      },
      onSelectDirection() {
        this.text.txList[0].taMove = this.selectedDirection
        this.showScrollDirectionPopup = false
      },
      onSelectAlignment() {
        this.text.txList[0].taAlignment = this.selectedAlignment
        this.showAlignmentPopup = false
      },
      getSpeedName(speed) {
        const option = this.speedOptions.find(option => option.value === speed)
        return option ? option.label : ''
      },
      getDirectionName(direction) {
        const option = this.directionOptions.find(option => option.value === direction)
        return option ? option.label : ''
      },
      getAlignmentName(alignment) {
        const item = this.Alignment.find((item) => item.value === alignment)
        return item ? item.name : ''
      }
    },
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
      }),
    },
  }
